
import { PayloadAction } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';
import { insertCharsAtPositions, insertCharsAtPositions2, getValueFromKey } from '@/utils/range';
import { canAddHighlight, getClearHighlightRanges, getHighlightPositions, normalizeHighlightPositions, subtractHighlightPositions } from '@/utils/highlight';
import { IClearHighlightPayload, IDeleteNotePayload, IUpdatePanel, IhightLightInfo, ILimitItem, IhightLightItem, IPanelData, IPageDataBoxType, IhightLightObj, IPosItem, IGenericObj, IAnswerItem } from '@/utils/ctype';

export const renderHightLightPage = (highLightObj: IhightLightObj, pageData: IPageDataBoxType, aiHightLightInfo?: IhightLightItem) => {
  const renderHightLight = Object.keys(highLightObj || {}).reduce((memo: {[key:string]: IPosItem[];}, key, index) => {
    const item = highLightObj[key];
    const { posObj, panelData } = item;
    const renderOrder = typeof item.createdAt === 'number' ? item.createdAt : index;
    for (const key in posObj) {
      if (!memo[key]) {
        memo[key] = [];
      }
      memo[key] = memo[key].concat(posObj[key].map((position) => ({
        ...position,
        uid: item.uid || position.uid,
        hasPanel: Boolean(panelData),
        renderOrder,
      })));
    }
    return memo;
  }, {});

  const renderAiOb = aiHightLightInfo?.posObj;
  const keys =renderAiOb ? Array.from(new Set(Object.keys(renderHightLight).concat(Object.keys(renderAiOb)))) : Object.keys(renderHightLight);

  // console.log('renderHightLight', JSON.stringify(renderHightLight));
  keys.forEach(key => {
    const posList = renderHightLight[key] || [];
    const sortList = posList.sort((a, b) => a.startOffset - b.startOffset || a.endOffset - b.endOffset);
    
    getValueFromKey(pageData, key, (value: string) => {
      if (renderAiOb && renderAiOb[key]) {
        return insertCharsAtPositions2(value, sortList, renderAiOb[key]);
      } else {
        return insertCharsAtPositions(value, sortList); }
    });
  });
};
  
export interface stateInterface {
  showNotePanel: boolean;
  pageDataAll: IPageDataBoxType[];
  pageDataCache: Array<IPageDataBoxType| undefined>;
  pageData: IPageDataBoxType | null;
  recordId: number;
  limits: ILimitItem[];
  answerAll: Array<IAnswerItem| null | undefined>;
  answerMap: IGenericObj<string[]>;
  currentFocus: number;
  pageDataIndex: number;
  loadAnswered: boolean;
  highLightInfo: IhightLightInfo;
  surplus_time: number;
  is_confirm: number;
  aiHightLightInfo?: IGenericObj<IhightLightItem>;
}


export const commonReducers ={
  updateTimeState: (state: stateInterface, {payload}: PayloadAction<number>) => {
    state.surplus_time = payload;
  },
  updateRecordId: (state: stateInterface, {payload}: PayloadAction<number>) => {
    state.recordId = payload;
  },
  toggleShowNotePanel: (state: stateInterface) => {
    state.showNotePanel = !state.showNotePanel;
  },
  setPanelDataByIndex: (state: stateInterface, {payload}: PayloadAction<{index: number; forceRender?: boolean;}>) => {
    const {index, forceRender} = payload;
    let pageDataCache = state.pageDataCache;
    const highLightInfo = state.highLightInfo;
    const aiHightLightInfo = state.aiHightLightInfo || {};
    
    
    if (!pageDataCache[index] || forceRender) {
      pageDataCache = [...pageDataCache];
      let curPageData = state.pageDataAll[index];
      if (highLightInfo[index] || aiHightLightInfo[index]) {
        curPageData = _.cloneDeep(curPageData);
        renderHightLightPage(highLightInfo[index], curPageData, aiHightLightInfo[index]);
      }
      pageDataCache[index] = curPageData;
      state.pageDataCache = pageDataCache;
    }
    state.pageData = state.pageDataAll[index];
    state.pageDataIndex = index;
  },
  setFocusIndex: (state:stateInterface, {payload}: PayloadAction<{index: number;}>) => {
    const {index} = payload;
    state.currentFocus = index;
  },
  saveHighlightData(state:stateInterface, {payload}: PayloadAction<{show: boolean;wrapUid: string;} & IhightLightItem>) {
    const pageDataIndex = state.pageDataIndex;
    const {show: showPanel, posArr, uid} = payload;
    let {panelData} = payload;
    if (!state.highLightInfo[pageDataIndex]) {
      state.highLightInfo[pageDataIndex] = {};
    }
    const highLightObj = state.highLightInfo[pageDataIndex];
    const candidate = normalizeHighlightPositions(posArr);
    if (!canAddHighlight(highLightObj, candidate, showPanel).allowed) {
      return;
    }

    const createdAt = payload.createdAt || Date.now();
    const retPosArr = candidate.map((item) => ({...item, uid, hasPanel: showPanel}));
    const retPos = retPosArr.reduce<IGenericObj<IPosItem[]>>((all, item) => {
      if (!all[item.dataKey]) {
        all[item.dataKey] = [];
      }
      all[item.dataKey].push(item);
      return all;
    }, {});
    const clonePageData = _.cloneDeep(state.pageDataAll[pageDataIndex]);

    if (showPanel && !panelData) {
      let title = '';
      retPosArr.forEach((item)=> {
        const {startOffset, endOffset, dataKey} = item;
        getValueFromKey(clonePageData, dataKey, (value: string) => {
          title += value.replace(/(\$[0-9]+\$|\n)/g, '').slice(startOffset, endOffset);
          return value;
        });
      });
      panelData = {title, content: '', timestamp: Date.now()};
    }

    highLightObj[uid] = {posObj: retPos, panelData, uid, posArr: retPosArr, createdAt};

    state.highLightInfo = {...state.highLightInfo};

    renderHightLightPage(highLightObj, clonePageData, (state.aiHightLightInfo || {})[pageDataIndex]);
    state.pageDataCache[pageDataIndex] = clonePageData;

  },
  hideDialog(state: stateInterface) {
    const pageDataIndex = state.pageDataIndex;
    const highLightObj = state.highLightInfo[pageDataIndex];
    if (highLightObj) {
      Object.keys(highLightObj).forEach((key: string) => {
        const item = highLightObj[key];
        return item;
      });
      state.highLightInfo = {...state.highLightInfo};
    }
    
  },
  showDialog(state: stateInterface, {payload}: PayloadAction<string>) {
    const pageDataIndex = state.pageDataIndex;
    const hightObj = state.highLightInfo[pageDataIndex];
    if (hightObj && hightObj[payload] && hightObj[payload].panelData) {
      state.highLightInfo = {...state.highLightInfo};
    }
    
    // if (highLightArr) {
    //   state.highLightInfo[pageDataIndex] = highLightArr.filter((item: {uid: string; show: boolean; panelData: {title: string; content: string;};}) => {
    //     if (item.panelData && item.uid === payload) {
    //       item.show = true;
    //     }
    //     return item;
    //   });
    // }
  },
  clearHightLightInfo(state: stateInterface, {payload}: PayloadAction<IClearHighlightPayload | undefined>) {
    
    const pageDataIndex = state.pageDataIndex;
    const highLightInfo = state.highLightInfo;
    const hightObj = highLightInfo[pageDataIndex];
    let curPageData = state.pageDataAll[pageDataIndex];

    if (!payload) {
      curPageData = _.cloneDeep(curPageData);
      renderHightLightPage({}, curPageData, (state.aiHightLightInfo || {})[pageDataIndex]);
      state.highLightInfo = {};
      state.pageDataCache = state.pageDataCache.map((item, index) => item ? state.pageDataAll[index] : item);
      state.pageDataCache[pageDataIndex] = curPageData;
      return;
    }

    if (hightObj && payload.posArr.length) {
      const clearRanges = getClearHighlightRanges(hightObj, payload.posArr);
      let changed = false;

      Object.keys(clearRanges).forEach((uid) => {
        const item = hightObj[uid];
        if (!item) {
          return;
        }
        const remaining = subtractHighlightPositions(getHighlightPositions(item), clearRanges[uid])
          .map((position) => ({
            ...position,
            uid: item.uid || uid,
            hasPanel: Boolean(item.panelData),
          }));
        changed = true;
        if (!remaining.length) {
          delete hightObj[uid];
          return;
        }
        item.posArr = remaining;
        item.posObj = remaining.reduce<IGenericObj<IPosItem[]>>((all, position) => {
          if (!all[position.dataKey]) {
            all[position.dataKey] = [];
          }
          all[position.dataKey].push(position);
          return all;
        }, {});
      });

      if (!changed) {
        return;
      }
      curPageData = _.cloneDeep(curPageData);
      renderHightLightPage(hightObj, curPageData, (state.aiHightLightInfo || {})[pageDataIndex]);
      state.highLightInfo = {...highLightInfo};
      state.pageDataCache[pageDataIndex] = curPageData;
    }
  },
  updatePanelInfo(state: stateInterface, {payload}: PayloadAction<IUpdatePanel>) {

    const hightLightInfo = state.highLightInfo;
    const pageDataIndex = payload.pageDataIndex ?? state.pageDataIndex;
    const highLightObj = hightLightInfo[pageDataIndex];
    const {uid, value} = payload;
    if (highLightObj?.[uid]?.panelData) {
      const {panelData} = highLightObj[uid];
      highLightObj[uid].panelData = {...(panelData as IPanelData), ...value};
    }
    state.highLightInfo = {...hightLightInfo};
  },
  deleteNote(state: stateInterface, {payload}: PayloadAction<IDeleteNotePayload>) {
    const {pageDataIndex, uid} = payload;
    const highLightObj = state.highLightInfo[pageDataIndex];
    const note = highLightObj?.[uid];
    if (!note?.panelData) {
      return;
    }

    delete highLightObj[uid];
    const sourcePageData = state.pageDataAll[pageDataIndex];
    if (sourcePageData) {
      const clonePageData = _.cloneDeep(sourcePageData);
      renderHightLightPage(highLightObj, clonePageData, (state.aiHightLightInfo || {})[pageDataIndex]);
      const pageDataCache = [...state.pageDataCache];
      pageDataCache[pageDataIndex] = clonePageData;
      state.pageDataCache = pageDataCache;
    }
    state.highLightInfo = {...state.highLightInfo};
  }
};
